import React from "react";
import { Search } from "MODULES/shared/components";
import {
  FilterSelect,
  SearchFilter,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { lotLineItemsPagination } from "MODULES/Lots/pagination";
import { CLEAR_FILTERS_TEXT } from "APP_ROOT/constants";
import { matchesBoolean } from "LIB/filters";

function SearchLotLineItems() {
  const defaultFilters = {
    at_shop: undefined,
    remaining_cost: undefined,
    remaining_inventory: undefined,
    received: undefined,
    sold: undefined
  };

  const filters = [
    {
      label: "Inventory with Remaining Cost",
      filters: { remaining_cost: true }
    },
    {
      label: "Location @ Shop",
      filters: { at_shop: true }
    },
    {
      label: "Only Remaining Inventory",
      filters: { remaining_inventory: true, sold: false }
    },
    {
      label: "Received",
      filters: { received: true }
    },
    {
      label: "Not Received",
      filters: { received: false }
    },
    {
      label: "Sold",
      filters: { sold: true, remaining_inventory: false }
    },
    {
      label: CLEAR_FILTERS_TEXT,
      filters: defaultFilters
    }
  ];

  const filterTags = [
    {
      label: "Inventory with Remaining Cost",
      key: "remaining_cost"
    },
    {
      label: "Location @ Shop",
      key: "at_shop"
    },
    {
      label: "Only Remaining Inventory",
      key: "remaining_inventory",
      matchesTarget: matchesBoolean(true)
    },
    {
      label: "Received",
      key: "received",
      matchesTarget: matchesBoolean(true)
    },
    {
      label: "Not Received",
      key: "received",
      matchesTarget: matchesBoolean(false)
    },
    {
      label: "Sold",
      key: "sold",
      matchesTarget: matchesBoolean(true)
    },
    {
      label: CLEAR_FILTERS_TEXT,
      filters: defaultFilters
    }
  ];

  return (
    <Search search={lotLineItemsPagination} syncWithUrl>
      {searchProps => (
        <div>
          <div
            className="form-group has-feedback-left"
            style={{ position: "relative" }}
          >
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by part number"
              />
              <FilterSelect {...searchProps} filters={filters} right />
            </div>
          </div>
          <TitleWithFilters {...searchProps} filters={filterTags} />
        </div>
      )}
    </Search>
  );
}

SearchLotLineItems.propTypes = {
  pushHistory: PropTypes.func.isRequired
};

export default connect(undefined, { pushHistory: push })(SearchLotLineItems);



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/LineItemsTable/Search.jsx